import React, { useEffect, useState } from "react";
import axios from "axios";
import "../styles/DaftarSurat.css";
import { Link } from "react-router-dom";
import Loader from "../components/Loader";

const DaftarSurat = () => {
  const [surahs, setSurahs] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchSurahs = async () => {
    try {
      const response = await axios.get("https://equran.id/api/v2/surat");
      setSurahs(response.data.data);
      setLoading(false);
    } catch (error) {
      console.error("error", error);
    }
  };

  useEffect(() => {
    fetchSurahs();
  }, [setSurahs]);

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="daftar-surat">
      <div className="daftar-surat__detail">
        {surahs.map((surah) => (
          <div className="daftar-surat__box" key={surah.nomor}>
            <Link
              to={`/detailSurat/${surah.namaLatin}/${surah.nomor}/0`}
              className="link"
            >
              <div className="daftar-surat__box-detail">
                <div className="daftar-surat__box-wrapper">
                  <h3 className="nomor-surah">{surah.nomor}</h3>
                  <div className="daftar-surat__box-body">
                    <h3 className="nama-latin">{surah.namaLatin}</h3>
                    <p className="info-surat">
                      {surah.tempatTurun} &#40;{surah.jumlahAyat}&#41;
                    </p>
                  </div>
                </div>
                <h3 className="nama-surah">{surah.nama}</h3>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DaftarSurat;
